import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { http } from "../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../consts/api";

const requestSchema = yup.object({
  patientIds: yup.array().of(yup.number().required()).required(),
});

export function useResendPortalBulkInviteMutation(options = {}) {
  return useMutation({
    mutationFn: (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });

      return http.post(HTTP_ENDPOINTS.patient.resendPortalBulkInvite(), {
        patient_ids: req.patientIds,
      });
    },
    ...options,
  });
}
